import React from 'react';
import Table, {ColumnType} from '@pluto/table';
import {IngestSessionInfo, SessionData} from './IngestSessionInfo';
import {IngestDataError} from '../IngestData/IngestDataTypes';

interface Props {
    tableColumns: ColumnType[];
    data: IngestDataError[];
    sessionData: SessionData;
    textEnums?: {
        feedProviders: {[key: string]: string};
        feedItemStatuses: {[key: string]: string};
    };
}

export default function IngestSessionError(props: Props) {
    const {tableColumns, data, sessionData, textEnums} = props;
    return (
        <div className="ingest-session-error">
            <div className="ingest-session-error__content">
                <Table columns={tableColumns} data={data}>
                    <IngestSessionInfo textEnums={textEnums} sessionData={sessionData} />
                    <div className="ingest-session-error__table-header">Details</div>
                </Table>
            </div>
        </div>
    );
}
